const getWishlistSkus = (items)=>{
    var ref;
    return (ref = items === null || items === void 0 ? void 0 : items.map((item)=>item.sku
    )) !== null && ref !== void 0 ? ref : [];
};

export { getWishlistSkus };
//# sourceMappingURL=get-wishlist-skus.js.map
